import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetCountryCodes extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Account/GetAllCountryCodes");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export { GetCountryCodes };
